import { j as a } from "../../../../jsx-runtime-CQ7OqOhn.js";
const o = ({ id: t }) => /* @__PURE__ */ a.jsx("p", { className: "flex text-caption-xs", "data-testid": `${t}-optional-text`, children: "Optional" });
export {
  o as default
};
